import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AuthProvider } from '../../providers/auth/auth';
import { AppConfig } from "../../providers/config";
import { PharmacyProvider } from '../../providers/pharmacy/pharmacy';

@IonicPage()
@Component({
  selector: 'page-program-pharmacies-add',
  templateUrl: 'program-pharmacies-add.html',
})
export class ProgramPharmaciesAddPage {

  program_id: string;
  program_name: string;
  user: any;
  provinces = AppConfig.Global.provinces;

  page_name: string;
  pharmacy: any;
  existing = false;

  pharmacyForm: FormGroup; 

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    private auth: AuthProvider,
    private pharmacyProvider: PharmacyProvider,
    private fb: FormBuilder) {
    
    this.createForm();

    this.auth.getCurrentUser().then(user => {
      this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };
      this.program_name = user.program_name;
      this.program_id = user.program_id;
    });

    if (this.navParams.get('pharmacydata')) {
      this.pharmacy = this.navParams.get('pharmacydata')
      //console.log('Existin Pharmacy: ', this.pharmacy);
      this.page_name = 'Edit ' + this.pharmacy.name;
      this.pharmacyForm.patchValue(this.pharmacy);
      this.existing = true;
    } else {
      this.pharmacy = null;
      this.page_name = 'Add Pharmacy';
      this.existing = false;
    }
  }

  createForm()  {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let phoneregex: RegExp = /^\+[1-9]\d{1,14}(\se?x?t?(\d*))?$/
    let cellfaxregex: RegExp = /^\+[1-9]\d{1,14}$/

    this.pharmacyForm = this.fb.group({
      'name': [null, [Validators.required]],
      'fax_number': [null, [Validators.required, Validators.pattern(cellfaxregex)]],
      'phone_number': [null, [Validators.required, Validators.pattern(phoneregex)]],
      'address': [null, [Validators.required]],
      'address2': [null],
      'city': [null, [Validators.required]],
      'province': [null, [Validators.required]],
      'postal_code': [null, [Validators.required]],
      'pharmacist_name': [null, [Validators.required]],
      'pharmacist_phone_number': [null, [Validators.required, Validators.pattern(phoneregex)]],
      'pharmacist_cell_number': [null, [Validators.pattern(cellfaxregex)]],
      'pharmacist_email': [null, [Validators.pattern(emailregex)]],
      'main_contact_name': [null],
      'main_contact_phone_number': [null, [Validators.pattern(phoneregex)]],
      'main_contact_cell_number': [null, [Validators.pattern(cellfaxregex)]],
      'main_contact_email': [null, [Validators.pattern(emailregex)]],
      'alt_contact_name': [null],
      'alt_contact_phone_number': [null, [Validators.pattern(phoneregex)]],
      'alt_contact_cell_number': [null, [Validators.pattern(cellfaxregex)]],
      'alt_contact_email': [null, [Validators.pattern(emailregex)]],
    });
  }

  savePharmacy() {
    const pharmacy = this.pharmacyForm.value;
    if (this.existing) {
      this.pharmacyProvider.updatePharmacy(this.program_id, this.pharmacy.id, pharmacy, this.user)
      .then(() => {
        this.navCtrl.pop();
      })
      .catch(err => {
        this.presentToast(err.message);
      })
    } else {
      this.pharmacyProvider.addPharmacy(this.program_id, pharmacy, this.user)
      .then(() => {
        this.navCtrl.pop();
      })
      .catch(err => {
        this.presentToast(err.message);
      })
    }
  }

  presentToast(message: string) {
    const toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/program-pharmacies-add/program-pharmacies-add.ts